module.exports = __webpack_public_path__ + "assets/img/num.8d5ac077.png";